import moment from 'moment';

export const moment2 = moment;

// https://momentjscom.readthedocs.io/en/latest/moment/04-displaying/01-format/
export const MOMENT_FORMAT = {
  DEFAULT: 'YYYY-MM-DDTHH:mm:ssZZ',
  YYYY_MM_DD_00_00_00: 'YYYY-MM-DD 00:00:00',
  YYYY_MM_DD_23_59_59: 'YYYY-MM-DD 23:59:59',
  YYYY_MM_DD_HH_MM_SS: 'YYYY-MM-DD HH:mm:ss',
  YYYYMMDDHHMMSS: "YYYYMMDDHHMMSS",
  YYYY_MM_DD_HH_MM_00: 'YYYY-MM-DD HH:mm:00',
  YYYY_MM_DD_HH_MM_59: 'YYYY-MM-DD HH:mm:59',
  YYYY_MM_DD: 'YYYY-MM-DD',
  YYYY_MM: 'YYYY-MM',
  HH_MM_SS: 'HH:mm:ss',
  HH_MM_00: 'HH:mm:00',
  MM_DD: 'MM-DD',
  DD_MM: 'DD-MM',
  D_MMM: 'D MMM',
  D_MMM_YYYY: 'D MMM YYYY',
  HH_MM: 'HH:mm',
  DD_MM_YYYY: 'DD-MM-YYYY',
  DD_MMM_YYYY: 'DD MMM YYYY',
  D_MMM_HH_mm: 'D MMM HH:mm',
  D_MMM_YYYY_HH_mm: 'DD MMM YYYY HH:mm',
  MMMM_YYYY: 'MMMM YYYY',
  DD_MM_YYYY_HH_mm_ss: "DD-MM-YYYY HH:mm:ss",
  DD_MM_YYYY_HH_mm: "DD-MM-YYYY HH:mm",
  MM_DD_YYYY: "MM-DD-YYYY",
  DD_MM_YY_HH_MM_SS: 'DD-MM-YY HH:mm:ss',
  DDMMYYYY_HHMM: "DD/MM/YYYY HH:MM",
  DDMMYYYY: "DD/MM/YYYY",
  DDMYYYY: "DD/M/YYYY",
  MMDDYYYY: "MM/DD/YYYY",
  YYYYMMDD: 'YYYYMMDD',
  MMM_DD_YYYY: 'MMM DD, YYYY',
  YYYY_MM_DD_HH_MM_SS_1: 'YYYY-MM-DD-HH:mm:ss',
  YYYY_MM_DDTHH_MM_SSZ: 'YYYY-MM-DDTHH:mm:ssZ',
  MMM_D_HH_mm: 'MMM D HH:mm',
  D_MMM_YY_HH_mm_ss: 'DD MMM YY HH:mm:ss',
  YYYY_MM_DD_HH_MM_A: 'YYYY-MM-DD hh:mm A',
  YYYY_MM_DD_HH_MM: 'YYYY-MM-DD HH:mm',
};
const SING_OFFSET = '+08:00';
// const EN_OFFSET = '+00:00';

export function parse2Str(
  date,
  format = MOMENT_FORMAT.DEFAULT,
  isTimezone = false
) {
  if (!date) {
    return ""
  }

  let rs;
  if (!isTimezone) {
    rs = moment(date, MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS).format(format);
  } else {
    rs = moment(date, MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS)
      .utcOffset(SING_OFFSET)
      .format(format)
  }

  return rs;
}

export function parse2Str2(
  date,
  format = MOMENT_FORMAT.DEFAULT,
  isTimezone = false
) {
  let rs;
  if (!isTimezone) {
    rs = moment(date, MOMENT_FORMAT.HH_MM_SS).format(format);
  } else {
    rs = moment(date, MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS)
      .utcOffset(SING_OFFSET)
      .format(format)
  }

  return rs;
}

export function parse2StrSin(date) {
  const rs = moment(date, MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS).utcOffset(SING_OFFSET)
  return rs;
}


export function convert2Date(date, inFormat, outFormat) {
  const rs = moment(date, inFormat)
    .utc(true)
    .format(outFormat)

  return rs;
}

export const addMinute = (date, minute, format) => {
  return moment(date)
    .add(minute, 'minutes')
    .format(format || MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS);
};

export function addMinute2(time, minutes, format) {
  return moment(time, MOMENT_FORMAT.HH_MM)
    .add(minutes, 'minutes')
    .format(format || MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS);
}

/**
 *
 * @param {*} date date / string / number
 * @returns [0-6]:[SUN-SAT] number
 */
export function getDayOfWeek(date) {
  const mDate = moment(date);
  const day = mDate.day();
  return day;
}

/**
 *
 * @param {*} date date / string / number
 */
export function getStartEndOfMonth(date) {
  const startOfMonth = moment(date).startOf('month').format(MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS);
  const endOfMonth = moment(date).endOf('month').format(MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS);
  return {
    start: startOfMonth,
    end: endOfMonth,
  };
}

export function getStartEndOfWeek(date) {
  const startOfWeek = moment(date).startOf('week').format(MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS);
  const endOfWeek = moment(date).endOf('week').format(MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS);
  return {
    start: startOfWeek,
    end: endOfWeek,
  };
}

/**
 *
 * @param {*} from date / string / number
 * @param {*} to date / string / number
 */
export function getRangeDate(from, to) {
  const mFrom = moment(from);
  const mTo = moment(to);

  if (mFrom.isAfter(mTo)) {
    return [];
  }
  if (mFrom.isSame(mTo)) {
    return [moment(mFrom).format(MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS)];
  }

  const rs = [];
  let mNext = moment(addDays(from, 0));
  do {
    rs.push(mNext.format(MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS));
    mNext = moment(addDays(mNext, 1));
  } while (!mNext.isAfter(mTo));
  return rs;
}
/**
 *
 * @param {*} date date / string / number
 */
export function splitDate2Component(date) {
  const mDate = moment(date);

  const day = mDate.format('DD');
  const month = mDate.format('MM');
  const year = mDate.format('YYYY');
  const hour = mDate.format('HH');
  const min = mDate.format('mm');
  const second = mDate.format('ss');
  return {
    day,
    month,
    year,
    hour,
    min,
    second,
  };
}

/**
*
* @param {*} date1 date / string / number
* @param {*} date2 date / string / number
*/
export function compareDate(date1, date2) {
  let mDate1 = moment(date1).format(MOMENT_FORMAT.YYYY_MM_DD);
  mDate1 = moment(mDate1);
  let mDate2 = moment(date2).format(MOMENT_FORMAT.YYYY_MM_DD);
  mDate2 = moment(mDate2);

  if (mDate1.isAfter(mDate2)) {
    return 1;
  } else if (mDate1.isSame(mDate2)) {
    return 0;
  } else {
    return -1;
  }
}

export function compareTime(time1, time2) {
  let mTime1 = moment(time1, MOMENT_FORMAT.HH_MM_SS);
  let mTime2 = moment(time2, MOMENT_FORMAT.HH_MM_SS)

  if (mTime1.isAfter(mTime2)) {
    return 1;
  } else if (mTime1.isSame(mTime2)) {
    return 0;
  } else {
    return -1;
  }
}

/**
*
* @param {*} date1 date / string / number
* @param {*} date2 date / string / number
*/
export function compareDateTime(date1, date2) {
  let mDate1 = moment(date1).format(MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS);
  mDate1 = moment(mDate1);
  let mDate2 = moment(date2).format(MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS);
  mDate2 = moment(mDate2);

  if (mDate1.isAfter(mDate2)) {
    return 1;
  } else if (mDate1.isSame(mDate2)) {
    return 0;
  } else {
    return -1;
  }
}

/**
 * 
 * @param {*} date date / string / number
 * @param {*} num integer
 */
export function addYears(date, num) {
  return moment(date).add(num, 'years').format(MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS);
}

/**
* 
* @param {*} date date / string / number
* @param {*} num integer
*/
export function addMonths(date, num) {
  return moment(date).add(num, 'months').format(MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS);
}

/**
* 
* @param {*} date date / string / number
* @param {*} num integer
*/
export function addDays(date, num, format = MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS) {
  return moment(date).add(num, 'days').format(format);
}

/**
* 
* @param {*} date date / string / number
* @param {*} hours integer
*/
export function addHours(date, hours, format) {
  return moment(date).add(hours, 'hours').format(format || MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS);
}

/**
* 
* @param {*} date date / string / number
* @param {*} minutes integer
*/
export function addMinutes(date, minutes, format) {
  return moment(date).add(minutes, 'minutes').format(format || MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS);
}

/**
* 
* @param {*} date date / string / number
* @param {*} minutes integer
*/
export function addMinutesNoFormat(date, minutes) {
  return moment(date).add(minutes, 'minutes').toDate();
}

/**
* 
* @param {*} date date / string / number
* @param {*} minutes integer
*/
export function addSeconds(date, seconds, format) {
  return moment(date).add(seconds, 'seconds').format(format || MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS);
}

/**
* 
* @param {*} date date / string / number
* @param {*} minutes integer
*/
export function addSecondsNoFormat(date, seconds) {
  return moment(date).add(seconds, 'seconds').toDate();
}

export function diff(start, end, format1, format2) {
  let _start = moment(start, format1 || MOMENT_FORMAT.YYYY_MM_DD);
  let _end = moment(end, format2 || format1 || MOMENT_FORMAT.YYYY_MM_DD);
  const duration = moment.duration(_end.diff(_start));
  return {
    hours: duration.asHours(),
    months: duration.asMonths(),
    days: duration.asDays()
  }
}

export function diff2(start, end) {
  let _start = moment(start);
  let _end = moment(end);
  const duration = moment.duration(_end.diff(_start));
  return {
    hours: duration.asHours(),
    month: duration.asMonths(),
    days: duration.asDays(),
  }
}

export function dateDiffSecond(start, end) {
  const date1 = new Date(start);
  const date2 = new Date(end);
  const diffTime = Math.abs(date2 - date1);
  return Math.ceil(diffTime / 1000);
}

export function isBetween(date, from, to) {
  return moment(date).isBetween(from, to);
}

export const formatDate = (date, patern = MOMENT_FORMAT.DD_MM_YYYY) => {
  return moment(new Date(date)).format(patern);
};

/**
  * Get count day of duration
  *
  * @param {*} start_date trip start date
  * @param {*} end_date  trip end date
  * @returns
  */
export const getNumberOfDuration = (start_date, end_date) => {
  start_date = formatDate(start_date, MOMENT_FORMAT.YYYY_MM_DD);
  end_date = formatDate(end_date, MOMENT_FORMAT.YYYY_MM_DD);
  if (start_date === end_date) {
    return 1;
  }
  return diff2(start_date, end_date).days;
};

/**
 * Subtract time
 * 
 * @param {*} startTime 
 * @param {*} endTime 
 * @returns 
 */
export const subtractTime = (startTime, endTime) => {
  const start = moment(startTime, MOMENT_FORMAT.HH_MM);
  const end = moment(endTime, MOMENT_FORMAT.HH_MM);
  const minutes = end.diff(start, 'minutes');
  return minutes;
}

/**
 * Subtract date then format HH:mm
 * 
 * @param {*} startTime 
 * @returns 
 */
export const subtractDateAndFormatHHmm = (startTime) => {
  // const date1 = moment(startTime, MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS);
  // const date2 = moment(new Date(), MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS);
  // const newDate = date2.diff(date1);
  return moment(new Date(), MOMENT_FORMAT.HH_MM);
}

// export function getDateWithoutTimezone(date, hours = -8) {
//   return moment(date).add(hours, 'hours').toDate();
// }

export function getDateWithTimezone(date, hours) {
  return moment(date).add(+hours, 'hours').toDate();
}

export function getDateWithoutTimezone(date) {
  const temp = date.toJSON().split('Z')[0].split('.')[0];
  return new Date(temp);
}

export const SubsequentSecond = (last, current) => {
  const start = moment(last)
  const end = moment(current)
  const minutes = end.diff(start, 'seconds');
  const ret = []
  if (minutes > 1) {
    for (var i = 0; i < minutes - 1; i++) {
      if (ret.length === 0) {
        ret.push(start.add(1, 'seconds').format(MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS))
      } else {
        var temp = moment(ret[i - 1])
        ret.push(temp.add(1, 'seconds').format(MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS))
      }
    }
  }
  return ret
}